module.exports = __webpack_public_path__ + "img/coupon-on-products.37106b3e.png";